import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PrescriptionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine.struct';

@Component({
    selector: 'app-prescricption-medicine-details',
    templateUrl: './prescricption-medicine-details.component.html',
    styleUrls: ['./prescricption-medicine-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescricptionMedicineDetailsComponent {

  constructor() { }

  @Input() prescriptionMedicine: PrescriptionMedicineStruct;

  ngOnInit(): void {}
}
